import { categories } from "@/mocks/home";

export default function Footer() {
  const footerColumns = [
    {
      title: "Categorias",
      links: categories.slice(0, 7).map((c) => ({ label: c.name, href: c.link })),
    },
    {
      title: "Mais Categorias",
      links: categories.slice(7, 14).map((c) => ({ label: c.name, href: c.link })),
    },
    {
      title: "Links Úteis",
      links: [
        { label: "CSSBuy Sheet", href: "https://kaspreadsheet.com" },
        { label: "Guia Completo", href: "/artigo/guia-completo-cssbuy-spreadsheet" },
        { label: "Buy It Now", href: "https://kaspreadsheet.com" },
        { label: "Contato", href: "mailto:contact@cssbuy.gay" },
      ],
    },
    {
      title: "Sobre",
      links: [
        { label: "Quem Somos", href: "/" },
        { label: "Política de Privacidade", href: "/" },
        { label: "Termos de Uso", href: "/" },
        { label: "FAQ", href: "/" },
      ],
    },
  ];

  return (
    <footer className="bg-foreground-950 py-16 md:py-20 px-8 md:px-14">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          {/* Left */}
          <div className="w-full lg:w-[35%]">
            <span className="font-heading text-2xl font-bold text-white">
              CSSBuy<span className="text-primary-500">.</span>gay
            </span>
            <p className="font-heading text-lg md:text-xl text-white/80 mt-6 leading-relaxed">
              Planilha verificada.<br />Compra segura.
            </p>
          </div>

          {/* Right - 4 columns */}
          <div className="w-full lg:w-[65%] grid grid-cols-2 sm:grid-cols-4 gap-8">
            {footerColumns.map((col) => (
              <div key={col.title}>
                <h4 className="text-sm font-semibold text-white mb-4">{col.title}</h4>
                <ul className="space-y-3">
                  {col.links.map((link) => (
                    <li key={link.label}>
                      {link.href.startsWith("http") ? (
                        <a
                          href={link.href}
                          target="_blank"
                          rel="noopener nofollow"
                          className="text-sm text-white/60 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                        >
                          {link.label}
                        </a>
                      ) : (
                        <a
                          href={link.href}
                          className="text-sm text-white/60 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
                        >
                          {link.label}
                        </a>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/40">
            &copy; 2026 CSSBuy.gay. Todos os direitos reservados.
          </p>
          <div className="flex items-center gap-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-9 h-9 flex items-center justify-center border border-white/20 rounded-lg text-white/50 hover:text-primary-400 hover:border-primary-400 transition-colors cursor-pointer"
            >
              <i className="ri-twitter-x-line text-sm"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-9 h-9 flex items-center justify-center border border-white/20 rounded-lg text-white/50 hover:text-primary-400 hover:border-primary-400 transition-colors cursor-pointer"
            >
              <i className="ri-instagram-line text-sm"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-9 h-9 flex items-center justify-center border border-white/20 rounded-lg text-white/50 hover:text-primary-400 hover:border-primary-400 transition-colors cursor-pointer"
            >
              <i className="ri-telegram-line text-sm"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-9 h-9 flex items-center justify-center border border-white/20 rounded-lg text-white/50 hover:text-primary-400 hover:border-primary-400 transition-colors cursor-pointer"
            >
              <i className="ri-discord-line text-sm"></i>
            </a>
          </div>
          <a href="/" className="text-xs text-white/40 hover:text-white/60 transition-colors cursor-pointer whitespace-nowrap">
            Política de Privacidade
          </a>
        </div>
      </div>
    </footer>
  );
}